import { BlobServiceClient } from "@azure/storage-blob";

import externalApi from "../helpers/externalAPIs";

const BLOB_SAS_URL = process.env.REACT_APP_BLOB_SAS_URL;
const DEFAULT_CONTAINER = "campaign-files";

class BlobService {
  constructor() {
    this.progress = 0;
  }

  async generateSASToken() {
    const res = await externalApi.get("/campaigns/sas-token");
    return res.data.data.token;
  }

  async uploadFile(userContainer, blobName, file, containerName) {
    const token = await this.generateSASToken();
    const blobServiceClient = new BlobServiceClient(`${BLOB_SAS_URL}?${token}`);
    const container = containerName || DEFAULT_CONTAINER;
    const containerClient = blobServiceClient.getContainerClient(
      container
    );

    const blockBlobClient = containerClient.getBlockBlobClient(blobName);
    const options = {
      blockSize: 4 * 1024 * 1024,
      concurrency: 20,
      onProgress: (ev) => {
        const progress = (ev.loadedBytes / file.size) * 100;
        this.progress = +progress.toFixed();
        if (this._onProgress) {
          this._onProgress(this.progress);
        }
      },
      blobHTTPHeaders: {
        blobContentType: file.type,
      },
    };

    await blockBlobClient.uploadData(file, options);
    return blockBlobClient.url;
  }

  async uploadFileWithProgress(userContainer, blobName, file, onProgress, containerName) {
    this._onProgress = onProgress || null;
    try {
      const url = await this.uploadFile(userContainer, blobName, file, containerName);
      return url;
    } finally {
      this._onProgress = null;
    }
  }
}

export default new BlobService();
